import React from 'react';
import PropTypes from 'prop-types';

import {
    Text,
    IconChevronRightCircle,
} from '@zillow/constellation';

import {
    StyledContainer,
    StyledHR,
    StyledSubTitleAndIcon,
    StyledWithSubTitleHeader,
} from './StyledComponents';

const propTypes = {
    panelModel: PropTypes.shape({
        isDisabled: PropTypes.bool.isRequired,
        message: PropTypes.string.isRequired,
        subtitle: PropTypes.string,
        title: PropTypes.string.isRequired,
        urlPath: PropTypes.string.isRequired,
    }),
};

const defaultProps = {
    panelModel: {},
};

const LayoutWithSubTitle = ({
    panelModel,
}) => {
    const {
        isDisabled,
        message,
        subtitle,
        title,
    } = panelModel;

    return (
        <StyledContainer className="LayoutWithSubTitle">
            <StyledWithSubTitleHeader>
                <Text
                    fontColor="brand"
                    fontType="bodyHeading"
                >
                    {title}
                </Text>

                <StyledSubTitleAndIcon>
                    <Text
                        className="Subtitle"
                        fontColor="brand"
                        fontType="finePrint"
                    >
                        {subtitle}
                    </Text>

                    {isDisabled === false && <IconChevronRightCircle fontColor="brand" size="sm" /> }
                </StyledSubTitleAndIcon>
            </StyledWithSubTitleHeader>

            <StyledHR
                marginTop="sm"
                marginBottom="md"
            />

            <Text
                as="div"
                fontType="bodySmall"
            >
                {message}
            </Text>
        </StyledContainer>
    );
};

LayoutWithSubTitle.propTypes = propTypes;
LayoutWithSubTitle.defaultProps = defaultProps;

export default LayoutWithSubTitle;
